import { action, makeObservable } from 'mobx';
import { MobxStore } from './types';

// BaseStore接口
export interface IBaseStore<TStore> {
  root: MobxStore | undefined;
  hydrate(data: RecursivePartial<TStore>): void;
}

class StoreBase<TName extends keyof MobxStore, TStore = MobxStore[TName]> implements IBaseStore<TStore> {
  root: MobxStore | undefined = undefined;
  constructor(root: MobxStore) {
    this.root = root;
    makeObservable(this);
  }

  @action hydrate = (data: RecursivePartial<TStore>) => {
    if (!data) return;
    try {
      const keys = Object.keys(data) as Array<keyof TStore>;
      keys.forEach((key) => {
        (this as RecursivePartial<TStore>)[key] = data[key];
      });
    } catch (e) {
      console.error(e);
    }
  };
}

export default StoreBase;
